var map = {
	"./academy/academy.module": [
		"./src/app/main/apps/academy/academy.module.ts",
		"common",
		"academy-academy-module"
	],
	"./chat/chat.module": [
		"./src/app/main/apps/chat/chat.module.ts",
		"chat-chat-module"
	],
	"./components-third-party/components-third-party.module": [
		"./src/app/main/documentation/components-third-party/components-third-party.module.ts",
		"components-third-party-components-third-party-module~dashboards-analytics-analytics-module",
		"common",
		"components-third-party-components-third-party-module"
	],
	"./components/components.module": [
		"./src/app/main/documentation/components/components.module.ts",
		"components-components-module~dashboards-analytics-analytics-module~dashboards-project-project-module",
		"common",
		"components-components-module"
	],
	"./contacts/contacts.module": [
		"./src/app/main/apps/contacts/contacts.module.ts",
		"common",
		"contacts-contacts-module"
	],
	"./dashboards/analytics/analytics.module": [
		"./src/app/main/apps/dashboards/analytics/analytics.module.ts",
		"components-components-module~dashboards-analytics-analytics-module~dashboards-project-project-module",
		"components-third-party-components-third-party-module~dashboards-analytics-analytics-module",
		"common",
		"dashboards-analytics-analytics-module"
	],
	"./dashboards/project/project.module": [
		"./src/app/main/apps/dashboards/project/project.module.ts",
		"components-components-module~dashboards-analytics-analytics-module~dashboards-project-project-module",
		"common",
		"dashboards-project-project-module"
	],
	"./directives/directives.module": [
		"./src/app/main/documentation/directives/directives.module.ts",
		"directives-directives-module"
	],
	"./getting-started/getting-started.module": [
		"./src/app/main/documentation/getting-started/getting-started.module.ts",
		"getting-started-getting-started-module"
	],
	"./mail-ngrx/mail.module": [
		"./src/app/main/apps/mail-ngrx/mail.module.ts",
		"mail-ngrx-mail-module"
	],
	"./mail/mail.module": [
		"./src/app/main/apps/mail/mail.module.ts",
		"mail-mail-module"
	],
	"./main/angular-material-elements/angular-material-elements.module": [
		"./src/app/main/angular-material-elements/angular-material-elements.module.ts",
		"main-angular-material-elements-angular-material-elements-module"
	],
	"./main/apps/apps.module": [
		"./src/app/main/apps/apps.module.ts",
		"main-apps-apps-module"
	],
	"./main/documentation/documentation.module": [
		"./src/app/main/documentation/documentation.module.ts",
		"main-documentation-documentation-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"common",
		"main-pages-pages-module"
	],
	"./main/ui/ui.module": [
		"./src/app/main/ui/ui.module.ts",
		"main-ui-ui-module"
	],
	"./services/services.module": [
		"./src/app/main/documentation/services/services.module.ts",
		"services-services-module"
	],
	"./tutors/tutors.module": [
		"./src/app/main/apps/tutors/tutors.module.ts",
		"common",
		"tutors-tutors-module"
	],
	"./working-with-fuse/working-with-fuse.module": [
		"./src/app/main/documentation/working-with-fuse/working-with-fuse.module.ts",
		"working-with-fuse-working-with-fuse-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;